import { selectActiveComparison, selectSelectedHistoricalScenarios } from '@/redux/modules/comparison/selectors';

import {
  useCalculateComparisonHistoricalScenariosQuery,
  useCalculateHistoricalScenariosQuery,
} from '@/redux/api/historical-scenarios/historical-scenarios-api';
import { deepClone } from '@/utils/objects';
import { useSelector } from 'react-redux';

export const useHistoricalScenarioAPIData = () => {
  const activeComparison = useSelector(selectActiveComparison);
  const selectedHistoricalScenarios = useSelector(selectSelectedHistoricalScenarios);

  const { data: calculatedScenariosFromData, isFetching: isFetchingData } = useCalculateHistoricalScenariosQuery(
    {
      historicalScenarios: deepClone(selectedHistoricalScenarios),
      togetherMode: true,
      baseCurrencyEnabled: activeComparison?.showBaseCurrencies || false,
      rebalanceFrequency: activeComparison?.options?.growth?.rebalancePeriod,
      shortHistory: activeComparison?.shortHistory || false,
      items:
        activeComparison?.items.map(item => {
          const newItem = deepClone(item);
          return {
            _id: newItem._id,
            name: newItem.name,
            type: newItem.type,
            discretionaryMer: newItem.discretionaryMer,
            holdings: newItem.holdings.map(h => ({ id: h.id, type: h.type, weight: h.weight, yieldParams: h.yieldParams })),
          };
        }) || [],
    },
    { skip: !activeComparison?.isDirty || activeComparison?._id?.startsWith('new_') || selectedHistoricalScenarios.length === 0 },
  );

  const { data: calculatedScenariosFromComparison, isFetching: isFetchingComparison } = useCalculateComparisonHistoricalScenariosQuery(
    {
      comparisonId: activeComparison?._id!,
      contactId: activeComparison?.contact?._id,
      historicalScenarios: deepClone(selectedHistoricalScenarios),
      rebalanceFrequency: activeComparison?.options?.growth?.rebalancePeriod,
      togetherMode: true,
    },
    { skip: activeComparison?.isDirty || activeComparison?._id?.startsWith('new_') || selectedHistoricalScenarios.length === 0 },
  );

  const calculatedHistoricalScenarios = activeComparison?.isDirty ? calculatedScenariosFromData : calculatedScenariosFromComparison;

  const isFetching = activeComparison?.isDirty ? isFetchingData : isFetchingComparison;
  return { calculatedHistoricalScenarios, isFetching };
};
